var exports = {
  "e": "CopilotLogoSuite__0e59tY",
};

module.exports = exports;
